import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import useTranslation from 'customHooks/translate';
import { ACCOUNT_INFO } from 'events/types';
import { getAccountData } from 'services/accounts';
import { getSubscriptionUrgencyLevel } from 'utils';
import { urgencyButtonStyles, urgencyIcons, urgencyPanelStyles } from 'consts';
import { useNavigate } from 'react-router-dom';

const SubscriptionNotification = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  const { data: accountInfo } = useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: getAccountData,
    select: (response) => response.data.data,
  });

  const expirationDate = accountInfo?.subscriptionExpiration;

  const urgencyLevel = useMemo(
    () => getSubscriptionUrgencyLevel(expirationDate),
    [expirationDate]
  );

  return (
    <div
      className={`flex flex-wrap gap-[7px] h-auto items-center justify-center py-[7px] text-center text-[14px] font-medium ${urgencyPanelStyles[urgencyLevel]}`}
    >
      {urgencyIcons[urgencyLevel]} {translation.sideMenu.PlanMainText}{' '}
      {translation.sideMenu.PlanExiryText}
      {expirationDate ? ` ${expirationDate}` : ''}
      {!accountInfo?.isSubUser && (
        <button
          type="button"
          onClick={() => navigate('/profile/payment')}
          className={`rounded-[6px] px-[10px] py-[5px] text-[12px] font-semibold transition-all ${urgencyButtonStyles[urgencyLevel]}`}
        >
          {translation.profile.pay}
        </button>
      )}
    </div>
  );
};

export default SubscriptionNotification;
